import Vue from 'vue'
import VueRouter from 'vue-router'
import authRoutes from './auth.routes'
import indexRoute from './index.route'
import communityRoute from './community.route'
import requestsRoute from './requests.route'
import residentsRoute from './residents.route'
import devicesRoute from './devices.route'
import visitorsRoute from './visitors.route'
import settingsRoute from './settings.route'

Vue.use(VueRouter)

const entryPoint = [];

const routes = [
    ...entryPoint,
    // index route only. Will call other routes for dashboard
    ...indexRoute,
    // community module routes
    ...communityRoute,
    // requests module
    ...requestsRoute,
    // visitor module
    ...visitorsRoute,
    // authentication routes. Login and signup for example
    ...authRoutes,
    ...devicesRoute,
    ...residentsRoute,
    ...settingsRoute
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    routes
});

export default router;
